import { render, staticRenderFns } from "./PubAdvertise.vue?vue&type=template&id=8519264c&scoped=true&"
import script from "./PubAdvertise.vue?vue&type=script&lang=js&"
export * from "./PubAdvertise.vue?vue&type=script&lang=js&"
import style0 from "./PubAdvertise.vue?vue&type=style&index=0&id=8519264c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8519264c",
  null
  
)

export default component.exports